__turbopack_context__.v({
  "accordion-reference": "gB9yZW_accordion-reference",
  "ant-collapse": "gB9yZW_ant-collapse",
  "ant-image": "gB9yZW_ant-image",
  "article-contents": "gB9yZW_article-contents",
  "article-image": "gB9yZW_article-image",
  "btn": "gB9yZW_btn",
  "btnFooter": "gB9yZW_btnFooter",
  "cards": "gB9yZW_cards",
  "category": "gB9yZW_category",
  "category-mobile": "gB9yZW_category-mobile",
  "col-btn-share": "gB9yZW_col-btn-share",
  "content": "gB9yZW_content",
  "copy-btn": "gB9yZW_copy-btn",
  "divider": "gB9yZW_divider",
  "headContact": "gB9yZW_headContact",
  "img-wrapp-share": "gB9yZW_img-wrapp-share",
  "list": "gB9yZW_list",
  "list-category": "gB9yZW_list-category",
  "list-desc": "gB9yZW_list-desc",
  "list-divider": "gB9yZW_list-divider",
  "list-img": "gB9yZW_list-img",
  "list-reviewer": "gB9yZW_list-reviewer",
  "list-title": "gB9yZW_list-title",
  "p": "gB9yZW_p",
  "page-body-wrap": "gB9yZW_page-body-wrap",
  "page-break-section": "gB9yZW_page-break-section",
  "pagehero": "gB9yZW_pagehero",
  "paragraph-content": "gB9yZW_paragraph-content",
  "paragraph1": "gB9yZW_paragraph1",
  "paragraph2": "gB9yZW_paragraph2",
  "paragraph3": "gB9yZW_paragraph3",
  "phonecontent": "gB9yZW_phonecontent",
  "related": "gB9yZW_related",
  "row-detail-share": "gB9yZW_row-detail-share",
  "section": "gB9yZW_section",
  "sectionright": "gB9yZW_sectionright",
  "share-btn": "gB9yZW_share-btn",
  "sosmed": "gB9yZW_sosmed",
  "store": "gB9yZW_store",
  "t": "gB9yZW_t",
  "title": "gB9yZW_title",
  "title1": "gB9yZW_title1",
  "wrap-article-detail": "gB9yZW_wrap-article-detail",
  "wrap-container": "gB9yZW_wrap-container",
  "wrap-content": "gB9yZW_wrap-content",
});
